import { Shark, SmartModel, Utils } from "shark-mvc";

import ApplicatorTimeRange from "./ApplicatorTimeRange";

class CCADetails extends SmartModel {
	constructor (data) {
		super();

		this.applicatorTeamGuid = "";
		this.cca = "";
		this.extraData = {
			ncrId: ""
		};
		this.guid = "";
		this.timeRanges = [];
		this.note = "";
		this.status = 1;
		this.timeSpanEnd = "0000-00-00 00:00:00";
		this.timeSpanStart = "0000-00-00 00:00:00";

		this.__constructionApplicatorTeam = "";
		this.__hasMultipleDates = false;
		this.__timeSpanEnd = "";
		this.__timeSpanStart = "";

		if (data) {
			this.import(data);
		}
	}

	addTimeRange (timeRange) {
		this.timeRanges.push(timeRange);
		this.checkTimeSpan(timeRange);
	}

	checkTimeSpan(timeRange) {
		if (timeRange.dateEnd > this.timeSpanEnd || (typeof this.timeSpanEnd === "string" && this.timeSpanEnd === "0000-00-00 00:00:00")) {
			this.timeSpanEnd = timeRange.dateEnd;
			this.parseTimeSpanEnd();
		}
		if (timeRange.dateStart < this.timeSpanStart || (typeof this.timeSpanStart === "string" && this.timeSpanStart === "0000-00-00 00:00:00")) {
			this.timeSpanStart = timeRange.dateStart;
			this.parseTimeSpanStart();
		}
	}

	export () {
		const exportData = this.__export();

		exportData.extraData = this.exportArrayField("extraData");

		exportData.timeRanges = this.exportArrayField("timeRanges");
		exportData.timeSpanEnd = this.exportDateField("timeSpanEnd");
		exportData.timeSpanStart = this.exportDateField("timeSpanStart");

		return exportData;
	}
	
	evaluateApplicatorName () {
		const applicatorTeamList = Shark.get("applicatorTeamList");

		if (applicatorTeamList) {
			const currApplicatorTeam = Utils.safp(applicatorTeamList, "guid", this.applicatorTeamGuid);

			if (currApplicatorTeam) {
				this.__constructionApplicatorTeam = currApplicatorTeam.name;
			}
		}
	}


	import (data, options) {
		this.__import(data, options);

		this.importNumberField("status", data.status);

		if (this.importDateField("timeSpanEnd", data.timeSpanEnd)) {
			this.parseTimeSpanEnd();
		}

		if (this.importDateField("timeSpanStart", data.timeSpanStart)) {
			this.parseTimeSpanStart();
		}

		this.evaluateApplicatorName();
		this.parseTimeRanges();
	}

	onTimeSpanEndChanged () {
		this.parseTimeSpanEnd();
	}

	onTimeSpanStartChanged () {
		this.parseTimeSpanStart();
	}

	parseTimeSpanEnd () {
		this.__timeSpanEnd = this.timeSpanEnd.format("YYYY-MM-DD");
		this.__timeSpanEndLabel = this.timeSpanEnd.format("DD/MM/YYYY");
	}

	parseTimeSpanStart () {
		this.__timeSpanStart = this.timeSpanStart.format("YYYY-MM-DD");
		this.__timeSpanStartLabel = this.timeSpanStart.format("DD/MM/YYYY");
	}

	parseTimeRanges () {
		//Dave: Questo serve perché dopo l'update della NCR, la singola riga restituita dall'Update di default di NousCore, non prende la riga "complessa" (con quindi anche il CCADetail collegato) ma solo il record base...
		//	 da sistemare con il famoso progetto della query di default per il singolo item.
		if (this.timeRanges) {
			this.timeRanges = this.timeRanges.map(item => {
				return new ApplicatorTimeRange(item);
			});
			
			this.__hasMultipleDates = this.timeRanges.length > 1;
		}
		else {
			this.__hasMultipleDates = false;
		}
	}
}

Shark.registerModel("CCADetails", CCADetails);

export default CCADetails;
